import { OutputDrug } from 'app/shared/models/medispan/output-drug';
import { OverrideDrug } from 'app/shared/models/medispan/override-drug';

export class MediSpanDto {
    DoctorPrescriptionId: number;
    Drugs: OutputDrug[];
    OverrideDrugs: OverrideDrug[];
}
